import Vue from 'vue';

export default Vue.component('smart-suggest-block', {
    template: `
      <div class="fl-as-basic-block">
        <div class="fl-as-block-header">
            <inline-svg class="fl-as-block-image" :src="icon"/>
            <h3 class="fl-as-block-text" >{{name}}</h3>
        </div>
        <div class="fl-as-block-content">
          <slot></slot>
        </div>
      </div>
    `,
    props: ['name', 'icon'],
});
